export default __webpack_public_path__ + "static/media/telegram.6110f804.svg";